import { validate } from 'validate.js';

(validate as any).options = {
    fullMessages: false,
};